import { newRequestKey } from '../../../components/messaging/requestKey';
// Backend staff-management contract is live. Single release rollback switch.
export const snippetFeatures = { enabled: true };
export const newSnippetKey = newRequestKey;
export const newSnippetUse = item => snippetFeatures.enabled && item?.id ? { snippet_id: item.id, snippet_use_key: newSnippetKey() } : {};
export const snippetSendFields = value => snippetFeatures.enabled && value?.snippet_id && value?.snippet_use_key
  ? { snippet_id: value.snippet_id, snippet_use_key: value.snippet_use_key } : {};
